module.exports = __webpack_public_path__ + "img/espa-en.9befaace.jpg";